import { ClientAnalyticsEventType } from "@hex/common";
import { editor as Editor } from "monaco-editor";
import { ICodeEditorService } from "monaco-editor/esm/vs/editor/browser/services/codeEditorService";

import { trackEvent } from "../../../util/trackEvent";

export type EmitSqlAutocompleteAcceptedPayload = [
  suggestionType:
    | "table"
    | "column"
    | "schema"
    | "database"
    | "keyword"
    | "identifier",
  networkRank: number,
  options?: { retriggerAutocomplete?: boolean },
];

export const EMIT_SQL_AUTOCOMPLETION_ACCEPTED_METRIC_CMD =
  "emitSqlAutoCompleteAcceptedMetric";

let registered = false;

export function registerSqlCompletionCommand(): void {
  if (registered) return;
  registered = true;
  Editor.registerCommand(
    EMIT_SQL_AUTOCOMPLETION_ACCEPTED_METRIC_CMD,
    (
      accessor: { get: (service: unknown) => any },
      ...[
        suggestionType,
        networkRank,
        { retriggerAutocomplete = false } = {},
      ]: EmitSqlAutocompleteAcceptedPayload
    ) => {
      // Autocomplete items can only run a single command on acceptance,
      // so we implement this custom command to trigger autocomplete and record metrics.

      if (retriggerAutocomplete) {
        // Based off of how monaco runs editor commands:
        // https://github.com/microsoft/vscode/blob/c9c3184b8854e41e45843bcd2448aab3193db0bb/src/vs/editor/browser/editorExtensions.ts#L300-L307
        const codeEditorService = accessor.get(ICodeEditorService);
        const editor: Editor.ICodeEditor | null =
          codeEditorService.getFocusedCodeEditor() ||
          codeEditorService.getActiveCodeEditor();

        editor?.trigger(null, "editor.action.triggerSuggest", null);
      }

      trackEvent(ClientAnalyticsEventType.AUTOCOMPLETE_ACCEPTED, {
        autocompleteProviderType: "SQL",
        networkRank,
        suggestionType,
      });
    },
  );
}
